import React, { useState } from "react";
import { WalletContext } from "./noteContext";

const WalletState = (props) => {
  const [walletConnection, setWalletConnection] = useState(false);
  const value = {  walletConnection, setWalletConnection };
  return <WalletContext.Provider value={value}>{props.children}</WalletContext.Provider>;
};

export default WalletState;
